import { beginBusyCursor } from './busyCursor.js';
import { translate } from './languageTranslator.js';

let releaseBusyCursor = null;

export function showLoadingBar(message = translate('address_search.please_wait')) {
  const loadingBar = document.getElementById('loading-bar');

  if (!releaseBusyCursor) releaseBusyCursor = beginBusyCursor();

  if (!loadingBar) return;

  const text = loadingBar.querySelector('[data-loading-text]');
  if (text) {
    text.textContent = message;
  }

  loadingBar.style.display = 'flex';
}

export function hideLoadingBar() {
  const loadingBar = document.getElementById('loading-bar');

  releaseBusyCursor?.();
  releaseBusyCursor = null;

  if (!loadingBar) return;

  loadingBar.style.display = 'none';
}
